export default __webpack_public_path__ + "static/media/Poleodomia.0557cbc4.png";